/// <amd-module name="VSS/Features/Charts/Internal/ChartTypesRegistry" />
import { CommonChartImplementation } from "./CommonChartImplementation";

import { equals } from "VSS/Core/Util/String";

export interface ChartType {
    /** Invariant name of the chart type */
    chartTypeName: string;

    /** Implementation of the chart type */
    constructor: new () => CommonChartImplementation;

    /** User/Screen-reader facing name of the chart type */
    userFacingChartTypeName: string;
}

/**
 * Registry of Chart types supported by charting.
 */
export class ChartTypesRegistry {
    private static _instance;

    public static getInstance(): ChartTypesRegistry {
        if (ChartTypesRegistry._instance == null) {
            ChartTypesRegistry._instance = new ChartTypesRegistry();
        }
        return ChartTypesRegistry._instance;
    }
    private _chartTypes: ChartType[];

    private constructor() {
        this._chartTypes = [];
    }

    public getChartType(typeName: string): ChartType {
        const index = this._chartTypes.findIndex(candidate => {
            return equals(candidate.chartTypeName, typeName);
        });
        return index >= 0 ? this._chartTypes[index] : null;
    }

    public registerChartType(chartType: ChartType): void {
        if (this.getChartType(chartType.chartTypeName) == null) {
            this._chartTypes.push(chartType);
        }
    }

    /**
     * Instantiates implementation for the given chart type.
     */
    public instantiateType(chartTypeName: string): CommonChartImplementation {
        const chartType = this.getChartType(chartTypeName);
        if (chartType == null) {
            throw Error("Unrecognized Chart Type");
        }
        return new chartType.constructor();
    }
}
